var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyTulu6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2068",
    "data-name": "Rectangle 2068",
    className: "cls-1",
    transform: "translate(1432 1220)",
    d: "M0 0h75v75H0z"
  })), /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#fff}\n        "))), /*#__PURE__*/React.createElement("g", {
    id: "Liability_insurance",
    "data-name": "Liability insurance",
    transform: "translate(-1432 -1220)",
    style: {
      clipPath: "url(#clip-path)"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_239",
    "data-name": "Group 239",
    transform: "translate(1440 1237.356)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4214",
    "data-name": "Path 4214",
    d: "M-788.693 2495.808H-831a4.06 4.06 0 0 1-4.055-4.055v-47.488a4.06 4.06 0 0 1 4.055-4.055h42.31a4.06 4.06 0 0 1 4.055 4.055v47.488a4.06 4.06 0 0 1-4.058 4.055zM-831 2441.9a2.366 2.366 0 0 0-2.363 2.363v47.488a2.366 2.366 0 0 0 2.363 2.363h42.31a2.366 2.366 0 0 0 2.363-2.363v-47.488a2.366 2.366 0 0 0-2.363-2.363z",
    transform: "translate(835.058 -2440.21)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_230",
    "data-name": "Group 230",
    transform: "translate(8.652 11.708)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_85",
    "data-name": "Line 85",
    className: "cls-1",
    transform: "translate(0 .846)",
    d: "M0 0h33.501"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1468",
    "data-name": "Rectangle 1468",
    d: "M0 0h33.501v1.692H0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_231",
    "data-name": "Group 231",
    transform: "translate(8.652 17.348)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_86",
    "data-name": "Line 86",
    className: "cls-1",
    transform: "translate(0 .846)",
    d: "M0 0h33.501"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1469",
    "data-name": "Rectangle 1469",
    d: "M0 0h33.501v1.692H0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_232",
    "data-name": "Group 232",
    transform: "translate(8.652 22.988)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_87",
    "data-name": "Line 87",
    className: "cls-1",
    transform: "translate(0 .846)",
    d: "M0 0h33.501"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1470",
    "data-name": "Rectangle 1470",
    d: "M0 0h33.501v1.692H0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_233",
    "data-name": "Group 233",
    transform: "translate(8.652 28.628)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_88",
    "data-name": "Line 88",
    className: "cls-1",
    transform: "translate(0 .846)",
    d: "M0 0h33.501"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1471",
    "data-name": "Rectangle 1471",
    d: "M0 0h33.501v1.692H0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_234",
    "data-name": "Group 234",
    transform: "translate(8.652 34.55)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_89",
    "data-name": "Line 89",
    className: "cls-1",
    transform: "translate(0 .846)",
    d: "M0 0h33.501"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1472",
    "data-name": "Rectangle 1472",
    d: "M0 0h33.501v1.692H0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_235",
    "data-name": "Group 235",
    transform: "translate(8.652 40.19)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_90",
    "data-name": "Line 90",
    className: "cls-1",
    transform: "translate(0 .846)",
    d: "M0 0h33.501"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1473",
    "data-name": "Rectangle 1473",
    d: "M0 0h33.501v1.692H0z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4215",
    "data-name": "Path 4215",
    d: "M-669.95 2447.666a2.88 2.88 0 0 0-2.876 2.876v40.641l2.885 7.038 2.867-7.038v-40.641a2.88 2.88 0 0 0-2.876-2.876zm-1.184 2.876a1.186 1.186 0 0 1 1.184-1.185 1.186 1.186 0 0 1 1.184 1.185v26.665h-1.523v1.692h1.523v1.128h-1.523v1.692h1.523v1.128h-1.523v1.692h1.523v1.128h-1.523v1.692h1.523v2.132h-2.368z",
    transform: "translate(726.574 -2445.196)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyTulu6);
export default __webpack_public_path__ + "static/media/myTulu6.02aa48f4c77e569852be7ccc817772b4.svg";
export { ForwardRef as ReactComponent };